import React from 'react';

const Services = () => {
    return (
        <section id="services" className="py-20 bg-white">
            <div className="container mx-auto px-6">
                <h2 className="text-3xl md:text-4xl font-serif-display text-center font-bold text-gray-800 mb-12 section-title">Our Expertise</h2>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                    {/* Property Card */}
                    <a href="#property" className="service-card bg-gray-50 rounded-lg p-8 text-center shadow-md hover:shadow-xl">
                        <h3 className="text-xl font-bold mb-2">Property & Asset</h3>
                        <p className="text-gray-600">Protecting your physical assets from unforeseen events.</p>
                    </a>
                    {/* Employee Benefits Card */}
                    <a href="#employee" className="service-card bg-gray-50 rounded-lg p-8 text-center shadow-md hover:shadow-xl">
                        <h3 className="text-xl font-bold mb-2">Employee Benefits</h3>
                        <p className="text-gray-600">Attract and retain top talent with comprehensive wellness programs.</p>
                    </a>
                    {/* Liability Card */}
                    <a href="#liability" className="service-card bg-gray-50 rounded-lg p-8 text-center shadow-md hover:shadow-xl">
                        <h3 className="text-xl font-bold mb-2">Liability & Risks</h3>
                        <p className="text-gray-600">Safeguarding your business from legal and professional liabilities.</p>
                    </a>
                    {/* Marine Card */}
                    <a href="#marine" className="service-card bg-gray-50 rounded-lg p-8 text-center shadow-md hover:shadow-xl">
                        <h3 className="text-xl font-bold mb-2">Marine & Cargo</h3>
                        <p className="text-gray-600">Securing your goods and vessels across global supply chains.</p>
                    </a>
                    {/* Engineering Card */}
                    <a href="#engineering" className="service-card bg-gray-50 rounded-lg p-8 text-center shadow-md hover:shadow-xl">
                        <h3 className="text-xl font-bold mb-2">Engineering</h3>
                        <p className="text-gray-600">Covering risks associated with construction and machinery projects.</p>
                    </a>
                    {/* Trade Credit Card */}
                    <a href="#trade-credit" className="service-card bg-gray-50 rounded-lg p-8 text-center shadow-md hover:shadow-xl">
                        <h3 className="text-xl font-bold mb-2">Trade Credit</h3>
                        <p className="text-gray-600">Protecting your accounts receivable from non-payment.</p>
                    </a>
                </div>
            </div>
        </section>
    );
};

export default Services;